import styled from '@emotion/styled';
import { Tooltip } from '@material-ui/core';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import _ModificationRequestInReviewIcon from './ModificationRequestInReviewIcon';

const ModificationRequestInReviewIconWithTooltip = () => (
  <FormattedMessage id="modification_request_state.in_review">
    {(text: string) => (
      <Tooltip placement="top" title={text}>
        <div>
          <ModificationRequestInReviewIcon size={24} />
        </div>
      </Tooltip>
    )}
  </FormattedMessage>
);

const ModificationRequestInReviewIcon = styled(_ModificationRequestInReviewIcon)({
  color: theme.palette.primary.main,
});

export default ModificationRequestInReviewIconWithTooltip;
